import React, { useEffect, useState } from "react"

import { Col, Divider, Space, Table } from "antd"
import { PrinterFilled } from "@ant-design/icons"
import Typography from "antd/es/typography/Typography"
import Sequence from "./Sequence"
import { collection, doc, onSnapshot, query, where } from "firebase/firestore"
import { db } from "../../../firebase/config"
import { tapePrintingColumns } from "./TapeTableColumns"

const { Title } = Typography

export default function TapePrintingTable({
  selectedRowKeysArsoma,
  setSelectedRowKeysArsoma,
  tableLoading,
}) {
  //loading data wich are meant to be for arsoma

  //arsoma printer data
  const [arsomaData, setArsomaData] = useState([])

  //array that manages order and gets updates
  const [arsomaSequence, setArsomaSequence] = useState(arsomaData.map((item) => item.id))
  //loading for while data is sorting
  const [isSorting, setIsSorting] = useState(true)

  //gets array of the sequence
  useEffect(() => {
    const sequenceDocRef = doc(db, "sequence", "lvYzqVUCJhcyuwSlJESD")
    const unsubscribe = onSnapshot(sequenceDocRef, (doc) => {
      if (doc.exists()) {
        const sequenceData = doc.data()
        setArsomaSequence(sequenceData.arsomaSequence)
        console.log("sequence")
      }
    })

    return () => unsubscribe()
  }, [])

  //fetches the documents, then uses the sequence array to sort in correct order
  useEffect(() => {
    const ref = collection(db, "orders")
    let q = query(
      ref,
      where("orderStatus", "==", 3.5),
      where("selectedProduct.machine", "==", "Tape")
    )

    const unsubscribe = onSnapshot(q, (snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        const data = doc.data()
        results.push({ ...data, key: doc.id, id: doc.id })
      })
      // sort the results based on the arsomaSequence state
      const sortedResults = results.sort((a, b) => {
        return arsomaSequence.indexOf(a.id) - arsomaSequence.indexOf(b.id)
      })
      setArsomaData(sortedResults)
      setIsSorting(false)
      console.log(sortedResults)
    })

    return () => unsubscribe()
  }, [arsomaSequence])

  //select for swaping data between tables
  const onSelectChangeArsoma = (newSelectedRowKeysArsoma) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeysArsoma)
    setSelectedRowKeysArsoma(newSelectedRowKeysArsoma)
  }

  const rowSelectionArsoma = {
    selectedRowKeysArsoma,
    onChange: onSelectChangeArsoma,
  }

  return (
    <div>
      {/* ARSOMA TABLE */}
      <Col span={24}>
        <Title level={4}>
          <PrinterFilled style={{ color: "green" }} />
          <Divider type="vertical" />
          Tape Printing List
        </Title>
        <Col span={24}>
          <Space>
            {/* <Sequence
              tableLoading={tableLoading}
              arsomaSequence={arsomaSequence}
              setArsomaSequence={setArsomaSequence}
              arsomaData={arsomaData}
              setArsomaData={setArsomaData}
            /> */}
          </Space>
        </Col>
        <Table
          style={{ marginTop: "15px" }}
          size="small"
          loading={isSorting || tableLoading}
          columns={tapePrintingColumns}
          dataSource={arsomaData}
          rowSelection={rowSelectionArsoma}
          rowKey={(record) => record.id}
          pagination={{ defaultPageSize: "12", showSizeChanger: true }}
        />
      </Col>
    </div>
  )
}
